import React from 'react'
import cls from 'classnames'
import { useTranslations } from 'next-intl'
import { Button } from 'components/ui/Button'
import useFeatureFlag from 'hooks/useFeatureFlag'

export interface ContactSupportProps {
  appearance?: 'link' | 'button'
  className?: string
  children?: React.ReactNode
}

export const ContactSupport = (props: ContactSupportProps) => {
  const { appearance = 'link', className, children } = props
  const supportMail = useFeatureFlag('common.support_mail')
  const t = useTranslations()

  const label = supportMail.isEnabled ? t('support_email') : t('support_tel')
  const value = supportMail.isEnabled
    ? t('support_email')
    : t('support_tel').replace(/\s/g, '')

  const linkType = supportMail.isEnabled ? 'mailto:' : 'tel:'
  const href = `${linkType}${value}`

  if (appearance === 'link') {
    return (
      <a href={href} className={cls('text-primary', className)}>
        {children ?? label}
      </a>
    )
  }

  return (
    <Button as="a" href={href} fullWidth className={className}>
      {supportMail.isEnabled ? t('contact_email_support') : t('call_hotline')}
    </Button>
  )
}
